import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { GET_CONTENT } from './query'
import prepareGetContentWriteQueryData from './prepareGetContentCacheData'

function isRecord (value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

/**
 * Apollo cache seeds for SSR GET_CONTENT. Member-home spotlight and tile rows
 * read from Redux hydrate / inline PM section — not Apollo cache — so only
 * detail (and similar) pages need writeQuery here.
 */
export function restoreApolloContentSeed (
  client: ApolloClient<NormalizedCacheObject>,
  seed: unknown,
) {
  if (!isRecord(seed)) {
    return
  }
  const { apollo } = seed
  if (!isRecord(apollo) || !apollo.data || !apollo.variables) {
    return
  }
  const preparedData = prepareGetContentWriteQueryData(apollo.data)
  if (!preparedData) {
    return
  }
  try {
    client.writeQuery({
      query: GET_CONTENT,
      variables: apollo.variables as Record<string, unknown>,
      data: preparedData,
    })
  } catch {
    // Cache seed is best-effort; client still falls back to network.
  }
}

export function restoreApolloContentSeeds (
  client: ApolloClient<NormalizedCacheObject>,
  hydrate: Record<string, unknown> | undefined,
) {
  restoreApolloContentSeed(client, hydrate?.detailHero)
}
